import { useEffect } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useAssinarAtividadeInicial = ({ dadosOs, sequencialAuto, siglaAtividade, formik }) => {
  const {
    request: assinarRequest,
    data: assinarData,
    errors: assinarErrors,
    isLoading: assinarIsLoading,
  } = useApiClient();

  const assinarAtividade = () => {
    const parametros = {
      sequencialOrdemServico: dadosOs.sequencial,
      sequencialAcaoFiscal: dadosOs.acaoFiscal,
      sequencialProdutoAcaoFiscal: sequencialAuto,
      sequencialTipoOcorrencia: formik.values.sequencialTipoOcorrencia,
      tipoAutoInfracao: formik.values.tipoAutoInfracao,
      descricaoOcorrencia: formik.values.descricaoOcorrencia,
      dataVencimento: formik.values.dataVencimento,
      dataPeriodoInicial: formik.values.dataPeriodoInicial,
      dataPeriodoFinal: formik.values.dataPeriodoFinal,
      txInfringenciaComplemento: formik.values.txInfringenciaComplemento,
      txPenalidadeComplemento: formik.values.txPenalidadeComplemento,
      sqItemOcorrencia: formik.values.sqItemOcorrencia,
      siglaAtividade, // Sigla Atividade 'AIE0', antes era -> 'AUGEIMAIES'
      nomeAtividade: "Auditor lavra Auto de Infração Especial", // "Auditor Gera e Imprime Auto de Infração Especial",
      txPreliminares: formik.values.txPreliminares,
      txProcedimentos: formik.values.txProcedimentos,
      txConstatacoes: formik.values.txConstatacoes,
      txOcorrencias: formik.values.txOcorrencias,
      txResultado: formik.values.txResultado,
    };

    assinarRequest(apiRoutes.fiscalizacao.autoinfracao.assinarAtividadeInicial, parametros);
  };

  useEffect(() => {
    if (assinarIsLoading) return;

    if (!assinarData && !assinarErrors) return;

    if (assinarData) {
      toast.success("Documento da atividade assinado com sucesso.");
      window.location.reload();
    }
  }, [assinarData, assinarErrors, assinarIsLoading]);

  return { assinarIsLoading, assinarAtividade, assinarErrors };
};

export default useAssinarAtividadeInicial;
